const questions = [
	{
		id: 0,
		question: '¿Cómo es la metodología de estudio en Libel Academy?',
		answer: [
			'Tenemos tres metodologías:',
			'Feedback en vivo.',
			'Campamentos.',
			'A tu ritmo.',
			'Consulta lo que ofrecemos en cada metodología dando click en “SOLICITAR ASESORÍA” y con gusto te orientamos',
		],
	},
	{
		id: 1,
		question: '¿Dónde se ven las clases?',
		answer: [
			'Todos los cursos en los que estás inscrito aparecerán en tu perfil, sección “mi portal”, es por ello que debes crear un perfil en nuestra plataforma de estudio:',
			'https://cursos.libel.academy/users/sign_up',
			'Las retroalimentaciones en vivo se realizan por Zoom y el acceso a ellas se envía a través de la plataforma y el Discord del curso en el cual estés inscrito. Las grabaciones de los feedback en vivo también aparecerán en tu perfil 24 horas hábiles después de cada retroalimentación en vivo.',
		],
	},
	{
		id: 2,
		question: 'Si el día de inicio del curso/máster no he recibido ningún acceso ¿Qué debo hacer?',
		answer: [
			'Asegúrate de haber llenado el formulario de inscripción, si no lo has hecho, contacta a la asesora que te acompañó durante el proceso de pago para que te envíe el formulario.',
			'Revisa tu correo en todas las carpetas para verificar si en efecto no te enviaron los accesos.',
			'Escribe a info@libeluniversity.org solicitando el acceso y adjuntando el comprobante de pago del curso/máster',
			'NOTA: Recuerda que los accesos se envían 2 días antes de iniciar el curso/máster',
		],
	},
	{
		id: 3,
		question:
			'¿Qué hacer si tengo problemas con el uso de la plataforma, el registro o la visualización de los cursos?',
		answer: [
			'Escribe un correo a soporte@libelstudios.com para que puedan ayudarte. Recuerda que el horario de soporte es de lunes a viernes de 9:00 am a 1:00 pm, hora Colombia. La respuesta a tu solicitud puede tardar entre 2 y 3 días hábiles. Agradecemos que seas paciente.',
		],
	},
	{
		id: 4,
		question: '¿Qué tipo de certificado se obtiene?',
		answer: [
			'A excepción del contenido gratuito, todos nuestros cursos/másteres/talleres son certificados. Se entrega un certificado de cumplimiento de metas si tus resultados son aprobados.',
		],
	},
	// {
	// 	id: 5,
	// 	question: '¿Proporcionan las licencias de los softwares que se usan en los cursos?',
	// 	answer: [
	// 		'Las únicas licencias que tenemos disponibles para entregar y/o vender son las licencias de Reallusion (Character Creator, Iclone, Headshot…) y licencias de ZBrush. Más información en el menú, sección Licencias.',
	// 	],
	// },
	// {
	// 	id: 6,
	// 	question: '¿Cuál es la diferencia entre un máster y un curso en vivo?',
	// 	answer: [
	// 		'Los másteres incluyen diferentes temas, diferentes softwares, cursos complementarios en vídeo y un nivel intermedio-avanzado, los cursos se centran en un único tema y software con un nivel básico-intermedio.',
	// 	],
	// },
	// {
	// 	id: 7,
	// 	question: '¿Qué medios de pago tienen?',
	// 	answer: [
	// 		'Puedes pagar con PayU (Transferencia bancaria, PSE, Nequi, tarjeta débito/crédito, Efecty, y Baloto), PayPal, Western Union y Tarjeta crédito. Recuerda que PayPal no está disponible para Colombia.',
	// 	],
	// },

	// {
	// 	id: 8,
	// 	question: '¿Tienen planes de financiación?',
	// 	answer: [
	// 		'Sí, tenemos planes de financiación sin interés, en nuestros cursos en vivo y másteres en vivo. Escríbenos acceder a esta opción.',
	// 	],
	// },

	// {
	// 	id: 9,
	// 	question: '¿Cuál es el horario de atención de Libel Academy?',
	// 	answer: [
	// 		'Nuestros canales de atención administrativa están abiertos en los siguientes:',
	// 		'horarios: Lunes a viernes: 8:00 am a 5:00 pm, hora Colombia Sábado: 8:00 am a 11:00 am, hora Colombia. Domingos y festivos (calendario colombiano) no hay atención Nuestro',
	// 		'canal de soporte está abierto en los siguientes horarios: Lunes a viernes: 9:00 am a 1:00 pm, hora Colombia Sábados, domingos y festivos (calendario colombiano) no hay atención.',
	// 		'Los canales de venta generalmente tienen un horario extendido del horario administrativo, sin embargo, la respuesta podría tardar un poco más si escribes después de las 6 pm, los sábados en la tarde o los domingos (tiempo de Colombia).',
	// 		'Las asesorías a estudiantes o aspirantes pueden agendarse en un horario diferente al horario administrativo. Consulta el calendario de asesorías para revisar los diferentes horarios disponibles. Si aún no tienes asesor, puedes solicitar uno a través del ícono de WhatsApp en nuestra página web.',
	// 		'Importante: Los horarios de clases, conferencias y/o eventos son independientes de los mencionados anteriormente y deben consultarse directamente en cada curso.',
	// 		'',
	// 	],
	// },
];

export default questions;
